<app-loader></app-loader>
<div class="intersting-outer">
  <div class="inter-heading">
    <h3>Interested in Learning More</h3>
    <p>Please Contact Us</p>
  </div>
  <form [formGroup]="landingForm" action="" #managerForm>
    <div class="grid">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="name-outer">
          <label for="name">Name <span class="custom-star">*</span></label>
          <input
            id="name"
            type="text"
            formControlName="name"
            pInputText
            class="custom-inputbox"
            placeholder="Enter name"
            maxlength="50"
          />
        </div>
        <div
          *ngIf="
            landingForm.get('name').hasError('required') &&
            (landingForm.get('name').dirty || landingForm.get('name').touched)
          "
        >
          <div class="validation-error">This field is required*</div>
        </div>
        <div
          *ngIf="
            landingForm.get('name').hasError('pattern') &&
            (landingForm.get('name').dirty || landingForm.get('name').touched)
          "
        >
          <div class="validation-error">Please enter only characters*</div>
        </div>
        <div
          *ngIf="
            landingForm.get('name').hasError('minlength') &&
            (landingForm.get('name').dirty || landingForm.get('name').touched)
          "
        >
          <div
            *ngIf="!landingForm.get('name').hasError('pattern')"
            class="validation-error"
          >
            Min 3 characters are required*
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="name-outer">
          <label for="email">Email <span class="custom-star">*</span></label>
          <input
            id="email"
            type="text"
            pInputText
            class="custom-inputbox"
            placeholder="Enter email ID"
            formControlName="email"
          />
          <div
            *ngIf="
              landingForm.get('email')?.hasError('pattern') &&
              (landingForm.get('email')?.dirty ||
                landingForm.get('email')?.touched)
            "
          >
            <div class="validation-error">Enter a Valid Email*</div>
          </div>
          <div
            *ngIf="
              landingForm.get('email')?.hasError('required') &&
              (landingForm.get('email')?.dirty ||
                landingForm.get('email')?.touched)
            "
          >
            <div class="validation-error">This field is required*</div>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="name-outer">
          <label for="phoneNumber"
            >Mobile number <span class="custom-star">*</span></label
          >
          <input
            id="phoneNumber"
            type="text"
            pInputText
            class="custom-inputbox"
            (keypress)="onKeyPress($event)"
            formControlName="phoneNumber"
            maxlength="15"
            placeholder="Enter Mobile number"
          />
          <div
            *ngIf="
              landingForm.get('phoneNumber').hasError('pattern') &&
              landingForm.get('phoneNumber').touched
            "
          >
            <div class="validation-error">Please enter only numbers*</div>
          </div>
          <div
            *ngIf="
              landingForm.get('phoneNumber')?.hasError('minlength') &&
              !landingForm.get('phoneNumber').hasError('pattern') &&
              (landingForm.get('phoneNumber')?.dirty ||
                landingForm.get('mobileNumber')?.touched)
            "
          >
            <div class="validation-error">Min length should be 9 digits*</div>
          </div>
          <div
            *ngIf="
              landingForm.get('phoneNumber')?.hasError('maxlength') &&
              !landingForm.get('phoneNumber').hasError('pattern') &&
              (landingForm.get('phoneNumber')?.dirty ||
                landingForm.get('mobileNumber')?.touched)
            "
          >
            <div class="validation-error">Max length should be 15 digits*</div>
          </div>
          <div
            *ngIf="
              landingForm.get('phoneNumber')?.hasError('required') &&
              (landingForm.get('phoneNumber')?.dirty ||
                landingForm.get('phoneNumber')?.touched)
            "
          >
            <div class="validation-error">This field is required*</div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <div class="name-outer message-outbox">
          <label for="message"
            >Message <span class="custom-star">*</span></label
          >
          <textarea
            pInputText
            class="custom-inputbox message-box"
            placeholder="Type here"
            id="message"
            formControlName="message"
            maxlength="500"
          ></textarea>
          <div
            *ngIf="
              landingForm.get('message').hasError('required') &&
              (landingForm.get('message').dirty ||
                landingForm.get('message').touched)
            "
          >
            <div class="validation-error message-error">
              This field is required*
            </div>
          </div>
          <div
            *ngIf="
              landingForm.get('message').hasError('minlength') &&
              (landingForm.get('message').dirty ||
                landingForm.get('message').touched)
            "
          >
            <div class="validation-error message-error">
              Min 3 characters are required*
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-outer">
      <button class="footer-btn" (click)="createEnquiry()" type="submit">
        Submit
      </button>
    </div>
  </form>
  <div class="copy-right">
    <h4>Copyright © 2024. All rights reserved by Trucklots.</h4>
    <ul class="terms-box">
      <li>
        <a href="terms-and-conditions" target="_blank">Terms & Conditions </a>
      </li>
      <li class="line-outer">|</li>
      <li><a href="privacypolicy" target="_blank"> Privacy Policy </a></li>
    </ul>
  </div>
</div>
